import * as Highcharts from 'highcharts';

export const defaultConfig: Highcharts.Options = {
  chart: {
    scrollablePlotArea: {
      minWidth: 500,
      opacity: 0.9,
      scrollPositionX: 0.5,
    },
  },
  xAxis: {
    labels: {
      autoRotation: [0, 30, 45, 60, 90],
    },
  },
  credits: {
    enabled: false,
  },
  title: {
    margin: 25,
    align: 'left',
  },
  subtitle: {
    align: 'left',
  },
  yAxis: {
    min: 0,
  },
  tooltip: {},
  legend: {
    reversed: true,
    align: 'center',
  },
  plotOptions: {
    columnrange: {
      grouping: false,
      borderWidth: 0,
    },

    series: {
      events: {
        legendItemClick: function (e) {
          e.preventDefault();
        },
      },
    },
  },
  exporting: {
    buttons: {
      contextButton: {
        menuItems: [
          'viewFullscreen',
          'printChart',
          'separator',
          'downloadPNG',
          'downloadJPEG',
          'downloadPDF',
          'downloadSVG',
        ],
      },
    },
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 500,
        },
        chartOptions: {
          legend: {
            enabled: false,
          },
          xAxis: {
            labels: {
              autoRotation: [0, 30, 45, 60, 90],
            },
          },
        },
      },
    ],
  },
};
